import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export type AlwaseetCity = {
  id: string;
  city_name: string;
};

export type AlwaseetRegion = {
  id: string;
  region_name: string;
};

export type AlwaseetPackageSize = {
  id: string;
  size: string;
};
export type AlwaseetOrder = {
  id: string;
  qr_id?: string | number;
  client_name: string;
  client_mobile: string;
  client_mobile2?: string;
  city_id?: string;
  city_name?: string;
  region_id?: string;
  region_name?: string;
  location: string;
  type_name: string;
  items_number: string | number;
  price: string | number;
  delivery_price?: string | number;
  package_size: string;
  merchant_notes?: string;
  issue_notes?: string;
  replacement: string | number;
  status_id?: string;
  status?: string;
  created_at?: string;
  updated_at?: string;
  merchant_invoice_id?: string;
  has_merchant_fin_record?: number | string;
  deliver_confirmed_fin?: number | string;
  urgent?: string | number;
  urgent_datetime_to_deliver?: string;
  deliver_estimation_datetime?: string;
};

export type AlwaseetStatus = {
  id: string;
  status: string;
};

export type AlwaseetInvoice = {
  id: string;
  merchant_price: string;
  delivered_orders_count: string;
  replacement_delivered_orders_count: string;
  status: string;
  merchant_id: string;
  updated_at: string;
};

export type CreateAlwaseetOrderPayload = {
  client_name: string;
  client_mobile: string;
  client_mobile2?: string;
  city_id: string | number;
  region_id: string | number;
  location: string;
  type_name: string;
  items_number: string | number;
  price: string | number;
  package_size: string | number;
  merchant_notes?: string;
  replacement: 0 | 1;
};

export type EditAlwaseetOrderPayload = CreateAlwaseetOrderPayload & {
  qr_id: string | number;
};

const callFn = async <T = any>(name: string, payload?: any): Promise<T> => {
  const fn = httpsCallable(functions, name);
  const result = await fn(payload);
  return result.data as T;
};

export const getAlwaseetCities = () =>
  callFn<AlwaseetCity[]>("alwaseetGetCities");

export const getAlwaseetRegions = (cityId: string) =>
  callFn<AlwaseetRegion[]>("alwaseetGetRegions", { cityId });

export const getAlwaseetPackageSizes = () =>
  callFn<AlwaseetPackageSize[]>("alwaseetGetPackageSizes");

export const createAlwaseetOrder = (payload: CreateAlwaseetOrderPayload) =>
  callFn<any>("alwaseetCreateOrder", payload);

export const editAlwaseetOrder = (payload: EditAlwaseetOrderPayload) =>
  callFn<any>("alwaseetEditOrder", payload);

export const getAlwaseetOrders = () =>
  callFn<AlwaseetOrder[]>("alwaseetGetOrders");

export const getAlwaseetStatuses = () =>
  callFn<AlwaseetStatus[]>("alwaseetGetStatuses");

export const getAlwaseetOrdersByIds = (ids: string[]) =>
  callFn<AlwaseetOrder[]>("alwaseetGetOrdersByIds", { ids });

export const getAlwaseetMerchantInvoices = () =>
  callFn<AlwaseetInvoice[]>("alwaseetGetMerchantInvoices");

export const getAlwaseetMerchantInvoiceOrders = (invoiceId: string) =>
  callFn<any>("alwaseetGetMerchantInvoiceOrders", { invoiceId });

export const receiveAlwaseetMerchantInvoice = (invoiceId: string) =>
  callFn<any>("alwaseetReceiveMerchantInvoice", { invoiceId });